export default class ConnectorContact {
    curveIndex;
    curveTime;
    connectionId;
    connectionSegmentPosition;

    constructor(curveIndex, curveTime, connectionId, connectionSegmentPosition) {
        this.curveIndex = curveIndex;
        this.curveTime = curveTime;
        this.connectionId = connectionId;
        this.connectionSegmentPosition = connectionSegmentPosition;
    }
}
